import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export interface KruseCredentialsDTO extends z.infer<typeof KruseCredentialsDTORuntype> {}
export const KruseCredentialsDTORuntype = z.object({
    client_id: z.string(),
    api_key: z.string(),
});

export interface KruseCredentialsInputDTO extends z.infer<typeof KruseCredentialsInputDTORuntype> {}
export const KruseCredentialsInputDTORuntype = z.object({
    client_id: z.string().optional(),
    api_key: z.string().optional(),
});

export interface KruseResponseBodyDTO extends z.infer<typeof KruseResponseBodyDTORuntype> {}
export const KruseResponseBodyDTORuntype = z.object({
    data: KruseCredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
